// extracted by mini-css-extract-plugin
export default {"skill_row":"Skill_skill_row__RcQuy","img_div":"Skill_img_div__bf7xo","skill_div":"Skill_skill_div__pqgHG"};